import { ResourceRoleSubject } from '../types';

export default function countSummary(value: ResourceRoleSubject[]): {
  member: number;
  group: number;
} {
  return value.reduce(
    (acc, v) => {
      if (v.subjectType === 'MEMBER') {
        acc.member += 1;
      }
      if (v.subjectType === 'GROUP') {
        acc.group += 1;
      }

      return acc;
    },
    { member: 0, group: 0 }
  );
}
